module.exports = __webpack_public_path__ + "img/close-sidebar.026ba67b.svg";